"use strict";

window.addEventListener("DOMContentLoaded", function (event) {
  var headerNav = document.querySelector(".header");
  if (headerNav != null) {
    var mobileTrigger = document.querySelector(".header__burger");
    var mainMobileNav = document.querySelector(".mobile-main-nav");
    var closeMobileNav = document.querySelector(".mobile-main-nav__close");
    var htmlEl = document.getElementsByTagName("html")[0];
    // Opens Mobile Nav
    mobileTrigger.addEventListener("click", function (e) {
      this.classList.add("mobile-open");
      htmlEl.classList.add("mobile-open");
      if (this.classList.contains("mobile-open")) {
        this.setAttribute("aria-expanded", "true");
      } else {
        this.setAttribute("aria-expanded", "false");
      }
      mainMobileNav.classList.add("mobile-open");
    });
    // Closes Mobile Nav
    closeMobileNav.addEventListener("click", function (e) {
      mobileTrigger.classList.remove("mobile-open");
      mainMobileNav.classList.remove("mobile-open");
      htmlEl.classList.remove("mobile-open");
      mobileTrigger.setAttribute("aria-expanded", "false");
    });
    var mainPanelItems = document.querySelectorAll(".mobile-main-nav__menu-item");
    // Open level 2 panel
    mainPanelItems.forEach(function (item) {
      item.addEventListener("click", function (e) {
        this.classList.add("open-panel");
        this.firstElementChild.setAttribute("aria-expanded", "true");
        mainMobileNav.classList.add("in-active");
        e.stopPropagation();
      });
    });
    var panelReturnBtns = document.querySelectorAll(".mobile-main-nav__panel-return");
    var setBtnAria = document.querySelectorAll(".mobile-main-nav__menu-item button");
    // Close level 2 panel reset aria
    panelReturnBtns.forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        this.parentElement.parentElement.classList.remove("open-panel");
        mainMobileNav.classList.remove("in-active");
        setBtnAria.forEach(function (item) {
          item.setAttribute("aria-expanded", "false");
        });
        e.stopPropagation();
      });
    });
    var closeAllmenus = document.querySelectorAll(".mobile-main-nav__panel-close");
    // Closes all panels and menu
    closeAllmenus.forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        htmlEl.classList.remove("mobile-open");
        mainMobileNav.classList.remove("in-active");
        mobileTrigger.classList.remove("mobile-open");
        mainMobileNav.classList.remove("mobile-open");
        var allPanels = document.querySelectorAll(".mobile-main-nav__menu-item");
        allPanels.forEach(function (panel) {
          if (panel.classList.contains("open-panel")) {
            panel.classList.remove("open-panel");
          }
        });

        // Sets Aria to false
        setBtnAria.forEach(function (item) {
          item.setAttribute("aria-expanded", "false");
        });
        e.stopPropagation();
      });
    });
    var locationsDropdownButton = document.querySelector(".mobile-main-nav__locations button");
    var locationsContainer = document.querySelector(".mobile-main-nav__locations");
    // Opens Health Sytem Locations menu
    locationsDropdownButton.addEventListener("click", function (e) {
      if (locationsContainer.classList.contains("expand-menu")) {
        locationsContainer.classList.remove("expand-menu");
      } else if (!locationsContainer.classList.contains("expand-menu")) {
        locationsContainer.classList.add("expand-menu");
      }
    });
  }
});